import musicboxClient from '@/utils/musicboxClient'
import i18n from '@/translations'
import localStorageUtil from '@/utils/localStorageUtil'
// import browserUtils from '@/utils/browserUtils'
import store from '@/store'
// import notificationPlugin from '@/plugin/notificationPlugin'
// const notificationActions = notificationPlugin.notificationActions

const ROOT = (window && window.STREAM_ROOT) ? window.STREAM_ROOT : 'https://stream.musicbox.hr/stream/'

var currentStream = null
const delay = 5000
var statusUpdatePaused = false
var statusRequestInProgress = false

const statusRequest = () => {
  if (store.state.audio.currentBox == null) { return }
  return musicboxClient.getBoxStatus(store.state.audio.currentBox.uuid)
    .then(res => {
      store.commit('setBoxStatus', res.data)
      /* if (!browserUtils.isMobile && res.data.playlist && res.data.playlist !== '' && store.state.audio.currentBox.is_web && !store.state.audio.audioPlaying) {
        play(store.state.audio.currentBox.uuid)
      } */
    })
    .catch(e => { console.log(e) })
}

const statusPoller = () => {
  if (store.state.auth.authorized === true && store.state.audio.currentBox != null && !statusUpdatePaused) {
    statusRequestInProgress = true
    statusRequest()
      .then(() => {
        statusRequestInProgress = false
        setTimeout(statusPoller, delay)
      })
  } else if (!statusRequestInProgress) {
    setTimeout(statusPoller, delay)
  }
}

statusPoller()

const pause = () => {
  if (store.state.audio.audioPlaying && currentStream) {
    currentStream.pause()
    // currentStream.load()
    store.commit('setAudioPlaying', false)
  }
}

const play = (boxUuid) => {
  var createdNow = false
  if (currentStream == null) {
    currentStream = new Audio(ROOT + boxUuid)
    createdNow = true
  }

  if (currentStream.src !== ROOT + boxUuid) {
    currentStream.pause()
    currentStream.src = ROOT + boxUuid
  } else if (store.state.audio.audioPlaying === false && !createdNow) {
    // currentStream.load()
  }

  currentStream
    .play()
    .then(() => { store.commit('setAudioPlaying', true) })
    // .catch(e => { console.log(e) })
    // .catch(e => { notificationActions.danger(i18n.t('Failed to start audio stream')) })

  /* setTimeout(() => {
    if (currentStream.error && currentStream.error.code === 4) {
      currentStream.src = null
      setTimeout(() => {
        currentStream.src = ROOT + boxUuid
        currentStream
          .play()
          .then(() => { store.commit('setAudioPlaying', true) })
          // .catch(e => { notificationActions.danger(i18n.t('Failed to start audio stream')) })
      }, 1)
    }
  }, 1000) */
}

export default {
  pause,
  play,
  pauseStatusUpdates: () => { statusUpdatePaused = true },
  continueStatusUpdates: () => { statusUpdatePaused = false },
  changeBox (box) {
    const audioWasPaying = store.state.audio.audioPlaying
    if (currentStream != null) { pause() }
    if (box.is_web && audioWasPaying) {
      play(box.uuid)
    }
    setTimeout(() => {
      localStorageUtil.setCurrentBox(box)
      store.commit('setCurrentBox', box)
      store.commit('setNotification', { message: i18n.t('Box changed to {boxName}', { boxName: box.name }), type: 'success' })
      if (box.is_web && audioWasPaying) {
        play(box.uuid)
      }
      setTimeout(() => { statusRequest() }, 256)
    }, 256)
  },
  forceUpdateStatus: () => {
    statusRequest()
  }
}



// WEBPACK FOOTER //
// ./src/utils/audioManager.js